import { OrderManagementPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import BarChart10FilledIcon from "@redotech/redo-web/icon-old/bar-chart-10-filled.svg";
import BarChart10Icon from "@redotech/redo-web/icon-old/bar-chart-10.svg";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import { useCustomAnalyticsReportsFeatureFlag } from "../../../../analytics/reports/custom/hooks/use-custom-analytics-reports-feature-flag";
import { useConversionLockedAction } from "../../../../conversion/locked/use-conversion-locked-action";

export const AnalyticsItems = memo(function AnalyticsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { locked, onLockedClick } = useConversionLockedAction(
    ScheduleDemoButtonLocation.NAV_ANALYTICS,
  );
  const canViewReports = useHasPermission(
    OrderManagementPermissions.VIEW_REPORTS,
  );
  const customReportsEnabled =
    useCustomAnalyticsReportsFeatureFlag().data ?? false;
  const showReports = canViewReports && customReportsEnabled;

  const conversionAnalyticsRoot = routes.conversionAnalyticsHref;
  const anyChildSelected = useMatch(`${conversionAnalyticsRoot}/*`);

  if (locked) {
    return (
      <RedoSecondaryNavItem
        action={{ type: "button", onClick: onLockedClick }}
        dimmed
        FilledIcon={BarChart10FilledIcon}
        friendlyName="Analytics"
        id="analytics"
        isPrivate
        UnfilledIcon={BarChart10Icon}
      />
    );
  }

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getConversionSubRoute("analytics/checkout"),
      }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={BarChart10FilledIcon}
      friendlyName="Analytics"
      id="analytics"
      UnfilledIcon={BarChart10Icon}
    >
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getConversionSubRoute("analytics/checkout"),
        }}
        friendlyName="Checkout"
        id="checkout-analytics"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getConversionSubRoute("analytics/post-purchase"),
        }}
        friendlyName="Post-purchase"
        id="post-purchase-analytics"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.conversionAnalyticsReportsHref }}
        beta
        friendlyName="Custom reports"
        hidden={!showReports}
        id="conversion-analytics-custom-reports"
      />
    </RedoSecondaryNavItem>
  );
});
